import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Tooltip, Divider } from '@mui/material';
import { motion } from 'framer-motion';
import { bgBlur } from '../../../utils/cssStyles';
import Iconify from '../../../components/iconify';
import AccountPopover from './AccountPopover';
import LanguagePopover from './LanguagePopover';
import AddOperator from './AddOperator';

const NAV_WIDTH = 264;
const HEADER_MOBILE = 60;
const HEADER_DESKTOP = 68;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default, blur: 10, opacity: 0.82 }),
  boxShadow: 'none',
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${NAV_WIDTH}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  paddingInline: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    paddingInline: theme.spacing(3),
  },
}));

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav }) {
  const { role } = useSelector((state) => state.account);

  return (
    <StyledRoot>
      <StyledToolbar>
        <motion.div
          initial={{ opacity: 0, y: -6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          style={{ display: 'flex', alignItems: 'center', width: '100%' }}
        >
          {/* Mobile menu button */}
          <Tooltip title="Menyu">
            <IconButton
              onClick={onOpenNav}
              sx={(theme) => ({
                mr: 1,
                color: 'text.primary',
                display: { lg: 'none' },
                '&:hover': { backgroundColor: theme.palette.grey[100] },
              })}
            >
              <Iconify icon="eva:menu-2-fill" width={20} />
            </IconButton>
          </Tooltip>

          <Box sx={{ flexGrow: 1 }} />

          {/* Right actions */}
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <AddOperator hidden={role !== 'admin'} />

            <Divider
              orientation="vertical"
              flexItem
              sx={{ mx: 0.75, my: 1, borderColor: 'grey.200' }}
            />

            <LanguagePopover />
            <AccountPopover />
          </Stack>
        </motion.div>
      </StyledToolbar>
    </StyledRoot>
  );
}
